import { render } from "./SidebarCategoriesScroll.vue?vue&type=template&id=3504bd33&scoped=true"
import script from "./SidebarCategoriesScroll.vue?vue&type=script&lang=js"
export * from "./SidebarCategoriesScroll.vue?vue&type=script&lang=js"

import "./SidebarCategoriesScroll.vue?vue&type=style&index=0&id=3504bd33&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3504bd33"]])

export default __exports__